import type { RoleConfig } from '../types.js';

export const maniac: RoleConfig = {
  id: 'maniac',
  faction: 'solo',
  title: { ru: 'Маньяк', uk: 'Маніяк' },
  latin: 'MANIAC',
  number: '10',
  accent: '#b6ff3a',
  sub: '#5a8a1a',
  ability: {
    ru: 'Ночью убивает одного игрока. Побеждает в одиночку.',
    uk: 'Вночі вбиває одного гравця. Перемагає на самоті.',
  },
  abilities: [
    {
      key: 'kill',
      phase: 'night',
      cadence: 'mandatory-night',
      canSelfTarget: false,
      killGroup: 'independent',
    },
  ],
  victory: { type: 'solo-last-standing' },
};
